import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {TableActionMenu} from "~/ui/ActionMenu/ActionMenu";

import { Button, Divider, HStack, Tooltip, } from "~/native-ui"

export default class TableActions extends Component {
	static propTypes = {
        modelId: PropTypes.string.isRequired,
        onAdd: PropTypes.func.isRequired,
        canCreate: PropTypes.bool.isRequired,
		addText: PropTypes.string.isRequired,
        createTooltip: PropTypes.string
	};

	render() {
		return (
			<HStack alignItems="center">
                <TableActionMenu modelId={this.props.modelId} />

				<React.Fragment>{this.props.canCreate && <Divider orientation="vertical" bg="coolGray.300" h="5" mx="2" />}</React.Fragment>

				<React.Fragment>
					{
						this.props.canCreate && 
						<Tooltip tooltip={this.props.addText}>
							<Button
								icon="add"
								primary
								iconSize="sm"
								onPress={this.props.onAdd}
							/>
						</Tooltip>
					}
				</React.Fragment>
			</HStack>
		);
	}
}